import { useSelectApolloQueryData } from '../../../../queryData/data/query-data-config';
import { TICKET_FIELD_NAME } from '../../../../queryData/data/field-names';
import { getAllRequiredValues } from '../../operators/pipelineGetters';
import { useTicketPipelines } from '../useTicketPipelines';
import { useCallback, useMemo } from 'react';
export const useTicketName = ticketId => {
  const {
    pipelines
  } = useTicketPipelines();
  const propertyNames = useMemo(() => {
    return ['subject', 'hs_ticket_category', ...getAllRequiredValues(pipelines)];
  }, [pipelines]);
  const selector = useCallback(response => {
    var _response$data;
    return {
      ticketName: (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.crmObject) === null || _response$data === void 0 || (_response$data = _response$data.defaultProperties) === null || _response$data === void 0 || (_response$data = _response$data.subject) === null || _response$data === void 0 ? void 0 : _response$data.value,
      loading: response.loading
    };
  }, []);
  const variables = useMemo(() => {
    return {
      ticketId: ticketId !== null && ticketId !== void 0 ? ticketId : 1,
      propertyNames
    };
  }, [ticketId, propertyNames]);
  const {
    ticketName,
    loading
  } = useSelectApolloQueryData({
    fieldName: TICKET_FIELD_NAME,
    variables,
    selector
  });
  return {
    ticketName,
    loading
  };
};